import { User } from "../store/serializers/users"
import userModel from "../store/models/user"
import { orderBy, isEmpty } from "lodash"

const iteratees = [o => o.ratings.length, "last_name"]
const orders = ["desc", "asc"]

const crewReducerDefaultState = {
  loadingCrew: true,
  crew: [],
  referCrewDialogOpen: false,
  searchkey: "",
  loadingCrewFromChip: true,
  crewlength: [],
  searchcrewLength: [],
  selectedCrewMember: null,
}

export default (state = crewReducerDefaultState, action) => {
  switch (action.type) {
    case "CREW::PERFORMING_SEARCH_FROM_CHIP":
      return {
        ...state,
        loadingCrew: action.loadingCrew,
      }

    case "CREW::LENGTH_PUSH_NEW":
      return {
        ...state,
        crewlength: action.data,
      }

    case "CREW::TOGGLE_REFER_CREW_DIALOG":
      return {
        ...state,
        referCrewDialogOpen: action.referCrewDialogOpen,
      }
    case "CREW::SET_SEARCH_KEY":
      return {
        ...state,
        searchkey: action.value,
      }
    case "CREW::PERFORMING_SEARCH":
      return {
        ...state,
        loadingCrew: action.loadingCrew,
      }
    case "CREW::SET_SEARCH_CREW_LENGTH":
      return {
        ...state,
        searchcrewLength: action.searchcrew,
      }
    case "CREW::SET_CREW":
      return {
        ...state,
        crew: [...state.crew, ...action.crew],
      }

    case "CREW::SET_CREW_SEARCH":
      return {
        ...state,
        crew: [...action.crew],
      }
    case "CREW::PUSH":
      if (action.crew.id) {
        return {
          ...state,
          crew: orderBy(
            [...state.crew, action.crew],
            ["master_rating"].concat(iteratees),
            ["desc"].concat(orders)
          ),
        }
      } else {
        return {
          ...state,
          crew: [],
        }
      }
    case "CREW::UPDATE_CREW_MEMBER":
      return {
        ...state,
        crew: state.crew.map(crew => {
          if (crew.id === action.updates.id) {
            crew = new User(userModel, {
              ...crew,
              ...action.updates,
            })
          }
          return crew
        }),
      }
    case "CREW::REMOVE_CREW_MEMBER":
      return {
        ...state,
        crew: state.crew.filter(c => c.id !== action.id),
      }
    case "CREW::CLEAR_CREW":
      return {
        ...state,
        crew: state.crew = [],
      }

    case "CREW::CLEAR_CREW_CHIP":
      return {
        ...state,
        crew: [],
      }
    case "CREW::SET_SELECTED_CREW_MEMBER":
      return {
        ...state,
        selectedCrewMember: action.id,
      }
    case "CREW::RATING::SET":
      return {
        ...state,
        crew: state.crew.map(c => {
          if (c.id === action.userId) {
            if (action.rating.hasOwnProperty("id")) {
              c.ratings = c.ratings.map(r => {
                if (r.id === action.rating.id) {
                  const newId = action.rating.newId
                  delete action.rating.newId
                  r = {
                    ...r,
                    ...action.rating,
                    id: newId,
                  }
                }
                return r
              })
            } else {
              let newRating = action.rating
              newRating.id = action.newId
              delete newRating.newId
              c.ratings = [...c.ratings, newRating]
            }
            c.avg_rating = action.avgRating
          }
          return c
        }),
      }
    default:
      return state
  }
}
